/**
 * Cookie-Banner ↔ Smile.io Launcher Spacing
 *
 * Wenn der Pandectes Cookie-Banner (`.pd-cookie-banner-window` / `.cc-window`)
 * unten am Viewport-Rand sichtbar ist, schieben wir den Smile.io Rewards-Launcher
 * (`#smile-ui-lite-launcher-frame-container`) darueber. Sobald der Banner weg ist
 * (User akzeptiert / lehnt ab), faellt der Launcher auf seine Default-Position
 * (20px bottom) zurueck.
 *
 * Beide Apps sind nicht im Theme — sie injizieren ihre Container per JS in den
 * Body. Wir koennen sie daher nur per Inline-Style (mit `!important`) ueber-
 * schreiben. Bei Resize / Banner-DOM-Aenderungen wird re-positioniert.
 */
(function () {
  'use strict';

  var SMILE_ID = 'smile-ui-lite-launcher-frame-container';
  var COOKIE_SELECTOR = '.pd-cookie-banner-window, .cc-window';
  var DEFAULT_BOTTOM = 20; // px (Smile-Default)
  var GAP = 16;            // px Abstand Banner → Launcher

  var lastBottom = null;

  function isVisible(el) {
    if (!el || !el.getBoundingClientRect) return false;
    var rect = el.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return false;
    var style = getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    if (parseFloat(style.opacity) < 0.01) return false;
    // Banner ausserhalb Viewport (z.B. translateY(100%) Hidden-State)
    if (rect.top >= window.innerHeight || rect.bottom <= 0) return false;
    return true;
  }

  function getBannerHeight() {
    var banner = document.querySelector(COOKIE_SELECTOR);
    if (!banner || !isVisible(banner)) return 0;
    // Wir wollen wissen wie viel Platz der Banner vom Viewport-Bottom belegt:
    // Wenn banner.bottom === window.innerHeight: Banner sitzt unten, Height = rect.height
    // Sonst (z.B. Banner ist zentriert / Modal): nicht hochschieben
    var rect = banner.getBoundingClientRect();
    var distanceFromBottom = window.innerHeight - rect.bottom;
    if (distanceFromBottom > 32) return 0; // Banner ist nicht bottom-fixed
    return rect.height + distanceFromBottom; // Banner-Height + ggf. eigener Margin
  }

  function update() {
    var launcher = document.getElementById(SMILE_ID);
    if (!launcher) return;
    var bannerH = getBannerHeight();
    var newBottom = bannerH > 0 ? bannerH + GAP : DEFAULT_BOTTOM;
    if (newBottom === lastBottom) return;
    launcher.style.setProperty('bottom', newBottom + 'px', 'important');
    lastBottom = newBottom;
  }

  // Beide Apps laden ASYNC nach DOMContentLoaded. Wir pollen sanft (300ms),
  // bis Smile-Launcher im DOM ist; danach immer noch periodisch, weil
  // Cookie-Banner DOM-Aenderungen (Open/Close-Animation, Resize) ueberraschend
  // kommen koennen ohne dass MutationObserver auf body subtree performant
  // waere.
  var pollInterval = setInterval(function () {
    update();
  }, 300);

  // Cleanup nicht zwingend (Page-Lifetime), aber falls SPA-Nav:
  window.addEventListener('beforeunload', function () {
    clearInterval(pollInterval);
  });

  // Bei Resize sofort reagieren
  window.addEventListener('resize', update, { passive: true });
  window.addEventListener('orientationchange', update, { passive: true });

  // Initialer Versuch bei DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }
})();
